import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';

import { useDialog, useRequestState } from '@app/hooks';
import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
  DeleteDialog,
} from '@app/components';
import { Strings } from '@app/constants';
import { ITestimonial } from '../types';
import { deleteTestimonial } from '../slice';
import { selectDeleteTestimonialState } from '../selector';
import { AddTestimonial } from './add-testimonial';

interface Props {
  row: ITestimonial | undefined;
}

const RowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const deleteDialog = useDialog();
  const editDialog = useDialog();
  const dispatch = useDispatch();

  const actions = [
    { label: Strings.rowActions.edit, callback: editDialog.show },
    { label: Strings.rowActions.delete, callback: deleteDialog.show },
  ];

  const { loading } = useRequestState({
    stateSelector: selectDeleteTestimonialState,
    onSuccess: deleteDialog.hide,
    successMessageShown: true,
    errorShown: true,
  });

  const onPressDelete = () => {
    dispatch(
      deleteTestimonial({
        id: row?.id,
      })
    );
  };

  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      <DeleteDialog
        title={`${Strings.common.delete} ${Strings.testimonial.testimonial}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.deleteCaption(Strings.testimonial.testimonial)}
        loading={loading}
        visible={deleteDialog.visible}
        onClickDelete={onPressDelete}
        onClose={deleteDialog.hide}
      />

      {editDialog.visible && <AddTestimonial open onClose={editDialog.hide} row={row} />}
    </>
  );
};

export { RowActions };
